import { css } from '@styled-system/css';

// Mise en page commune des onglets de la modal settings (Compte, Paiement), pour qu'ils restent identiques.

export const tabContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '6',
  paddingY: '4',
});

export const tabSection = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '3',
  paddingY: '2',
});

export const tabSectionCopy = css({
  fontSize: 'caption',
  color: 'text.tertiary',
  lineHeight: 'body',
  maxWidth: '520px',
});

export const tabRow = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '5',
  paddingY: '4',
});

export const tabLabelColumn = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2',
  minWidth: 0,
});

export const tabLabelText = css({
  fontSize: 'bodySm',
  fontWeight: 'medium',
  color: 'text.primary',
});

export const tabValueText = css({
  fontSize: 'bodySm',
  color: 'text.secondary',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});
